var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/buildRegionParamValue.ts
import cjkSlug from "cjk-slug";
function buildRegionParamValue(args) {
  return args.region.name ? `${cjkSlug(args.region.name)}-${args.region.id}` : args.region.id;
}
__name(buildRegionParamValue, "buildRegionParamValue");

// src/canonicalize.ts
import { compact } from "remeda";

// src/parseHostname.ts
import * as R from "remeda";

// src/iso3166.ts
function iso3166() {
  return [
    "AF",
    "AX",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AQ",
    "AG",
    "AR",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BE",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BO",
    "BQ",
    "BA",
    "BW",
    "BV",
    "BR",
    "IO",
    "BN",
    "BG",
    "BF",
    "BI",
    "CV",
    "KH",
    "CM",
    "CA",
    "KY",
    "CF",
    "TD",
    "CL",
    "CN",
    "CX",
    "CC",
    "CO",
    "KM",
    "CG",
    "CD",
    "CK",
    "CR",
    "CI",
    "HR",
    "CU",
    "CW",
    "CY",
    "CZ",
    "DK",
    "DJ",
    "DM",
    "DO",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "ET",
    "FK",
    "FO",
    "FJ",
    "FI",
    "FR",
    "GF",
    "PF",
    "TF",
    "GA",
    "GM",
    "GE",
    "DE",
    "GH",
    "GI",
    "GR",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GG",
    "GN",
    "GW",
    "GY",
    "HT",
    "HM",
    "VA",
    "HN",
    "HK",
    "HU",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IE",
    "IM",
    "IL",
    "IT",
    "JM",
    "JP",
    "JE",
    "JO",
    "KZ",
    "KE",
    "KI",
    "KP",
    "KR",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MO",
    "MK",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MH",
    "MQ",
    "MR",
    "MU",
    "YT",
    "MX",
    "FM",
    "MD",
    "MC",
    "MN",
    "ME",
    "MS",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NL",
    "NC",
    "NZ",
    "NI",
    "NE",
    "NG",
    "NU",
    "NF",
    "MP",
    "NO",
    "OM",
    "PK",
    "PW",
    "PS",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PN",
    "PL",
    "PT",
    "PR",
    "QA",
    "RE",
    "RO",
    "RU",
    "RW",
    "BL",
    "SH",
    "KN",
    "LC",
    "MF",
    "PM",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SX",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "GS",
    "SS",
    "ES",
    "LK",
    "SD",
    "SR",
    "SJ",
    "SZ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TL",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TC",
    "TV",
    "UG",
    "UA",
    "AE",
    "GB",
    "US",
    "UM",
    "UY",
    "UZ",
    "VU",
    "VE",
    "VN",
    "VG",
    "VI",
    "WF",
    "EH",
    "YE",
    "ZM",
    "ZW"
  ];
}
__name(iso3166, "iso3166");

// src/possibleCountryCodes.ts
var possibleCountryCodes = [
  ...iso3166().map((c) => c.toLowerCase()),
  // exceptions
  "uk"
];
var isValidCountryCode = /* @__PURE__ */ __name((value) => possibleCountryCodes.includes(value), "isValidCountryCode");

// src/dedupeCountryCode.ts
var dedupeCountryCode = /* @__PURE__ */ __name(({ dirs }) => {
  const [countryCodeDir, ...rest] = dirs;
  if (!isValidCountryCode(countryCodeDir)) {
    return {
      explicitCountryCode: null,
      outDirs: dirs
    };
  }
  const countryCode = countryCodeDir === "gb" ? "uk" : countryCodeDir;
  return {
    explicitCountryCode: countryCode,
    outDirs: rest
  };
}, "dedupeCountryCode");

// src/wellKnownOrigins.ts
var wellKnownOrigins = {
  /**
   * 프로덕션 및 알파
   */
  "daangn.com": "kr",
  /**
   * NOTE: subdomain에 아무런 국가 코드가 없는 경우 암묵적으로 "us"로 간주함.
   */
  "karrotmarket.com": null,
  "karrot.com": null,
  "karrotapp.com": null,
  /**
   * 로컬 테스트
   */
  "ca.localhost": "ca",
  "us.localhost": "us",
  "jp.localhost": "jp",
  "kr.localhost": "kr",
  "uk.localhost": "uk",
  /**
   * Kontrol 내부 테스트
   */
  "karrotmarket-com.jp.krmt.io": "jp",
  "karrotmarket-com.ca.krmt.io": "ca",
  "karrotmarket-com.uk.krmt.io": "uk",
  "karrotmarket-com.kr.krmt.io": "kr",
  "karrotmarket-com.jp.karrotmarket.com": "jp",
  "karrotmarket-com.ca.karrotmarket.com": "ca",
  "karrotmarket-com.uk.karrotmarket.com": "uk",
  "karrotmarket-com.kr.karrotmarket.com": "kr",
  "karrotmarket-com.alpha.jp.krmt.io": "jp",
  "karrotmarket-com.alpha.ca.krmt.io": "ca",
  "karrotmarket-com.alpha.uk.krmt.io": "uk",
  "karrotmarket-com.alpha.kr.krmt.io": "kr",
  "karrotmarket-com.alpha.jp.karrotmarket.com": "jp",
  "karrotmarket-com.alpha.ca.karrotmarket.com": "ca",
  "karrotmarket-com.alpha.uk.karrotmarket.com": "uk",
  "karrotmarket-com.alpha.kr.karrotmarket.com": "kr"
};

// src/parseHostname.ts
function parseHostname(hostname) {
  const dirs = hostname.split(".").filter((dir) => dir !== "www").filter((dir) => dir !== "alpha").filter((dir) => dir !== "hoian").reverse();
  const alpha = hostname.split(".").includes("alpha");
  const [wellKnownOrigin, implicitCountryCode] = R.pipe(
    Object.entries(wellKnownOrigins),
    R.filter(([wellKnownDomain]) => {
      const wellKnownOriginDirs2 = wellKnownDomain.split(".").reverse();
      if (dirs.length < wellKnownOriginDirs2.length) {
        return false;
      }
      for (let i = 0; i < wellKnownOriginDirs2.length; i += 1) {
        const matchDomainPath = dirs[i] === wellKnownOriginDirs2[i];
        if (!matchDomainPath) {
          return false;
        }
      }
      return true;
    }),
    /**
     * @description URL의 길이가 길수록 더 정확한 정보를 담고 있을거라 가정.
     */
    R.sort(([a], [b]) => b.length - a.length),
    R.first()
  ) ?? [null, null];
  if (!wellKnownOrigin) {
    return {
      countryCode: null,
      alpha,
      dirs: []
    };
  }
  const wellKnownOriginDirs = wellKnownOrigin.split(".");
  const dirsWithoutWellKnownOriginDirs = dirs.slice(
    wellKnownOriginDirs.length,
    dirs.length + 1
  );
  const { explicitCountryCode, outDirs } = dedupeCountryCode({
    dirs: dirsWithoutWellKnownOriginDirs
  });
  const countryCode = explicitCountryCode ?? implicitCountryCode;
  return {
    countryCode,
    dirs: outDirs,
    alpha
  };
}
__name(parseHostname, "parseHostname");

// src/parsePathname.ts
function parsePathname(pathname) {
  const dirs = pathname.split("/").flatMap((dir) => {
    const [path, search] = dir.split("?");
    if (!search) {
      return [path];
    }
    if (path === "") {
      return [`?${search}`];
    }
    return [path, `?${search}`];
  }).filter((dir) => dir !== "").filter((dir) => dir !== ".preview");
  const { explicitCountryCode, outDirs } = dedupeCountryCode({ dirs });
  const ignoreHostname = outDirs[0] === "p";
  if (ignoreHostname) {
    outDirs.splice(0, 1);
  }
  return {
    countryCode: explicitCountryCode,
    dirs: outDirs,
    ignoreHostname
  };
}
__name(parsePathname, "parsePathname");

// src/normalizeUrl.ts
function normalizeUrl({
  url,
  fallbackCountryCode
}) {
  const u = new URL(url);
  const hostname = parseHostname(u.hostname);
  const pathname = parsePathname(u.pathname);
  const countryCode = pathname.countryCode ?? hostname.countryCode ?? null;
  const finalCountryCode = countryCode ?? fallbackCountryCode ?? "us" /* US */;
  if (pathname.ignoreHostname) {
    return {
      countryCode: finalCountryCode,
      normalizedPath: `/${[[finalCountryCode, ...pathname.dirs].join("/")]}/${u.search}`,
      alpha: hostname.alpha
    };
  }
  const dirs = [...hostname.dirs, ...pathname.dirs];
  return {
    countryCode: finalCountryCode,
    normalizedPath: `/${[finalCountryCode, ...dirs].join("/")}/${u.search}`,
    alpha: hostname.alpha
  };
}
__name(normalizeUrl, "normalizeUrl");

// src/canonicalize.ts
function createCanonicalize(stage) {
  const origins = canonicalOrigins[stage];
  return (params) => {
    return canonicalize({ ...params, canonicalOriginsWithStage: origins });
  };
}
__name(createCanonicalize, "createCanonicalize");
function canonicalize({
  url,
  fallbackCountryCode = "us",
  canonicalOriginsWithStage
}) {
  const { normalizedPath, countryCode } = normalizeUrl({
    url,
    fallbackCountryCode
  });
  const canonicalOrigin = getCanonicalOrigin(
    canonicalOriginsWithStage,
    countryCode
  );
  const normalizedUrl = new URL(canonicalOrigin + normalizedPath);
  const outDirs = getOutDirs(normalizedUrl);
  const canonicalPath = outDirs.length > 0 ? `/${outDirs.join("/")}/${normalizedUrl.search}` : `/${normalizedUrl.search}`;
  const canonicalUrl = new URL(canonicalOrigin + canonicalPath);
  return {
    /**
     * @description URL.href
     * @example "https://karrotmarket.com/ca/hello/?world=true"
     */
    canonicalUrl: canonicalUrl.toString(),
    /**
     * @description URL.pathname
     * @example "/ca/hello/?world=true"
     */
    normalizedPath,
    countryCode
  };
}
__name(canonicalize, "canonicalize");
function getOutDirs(normalizedUrl) {
  const { countryCode: countryCodeFromPath, dirs } = parsePathname(
    normalizedUrl.pathname
  );
  if (countryCodeFromPath === "us") {
    return dirs;
  }
  if (normalizedUrl.origin.includes("daangn.com")) {
    return ["kr", ...dirs];
  }
  return compact([countryCodeFromPath, ...dirs]);
}
__name(getOutDirs, "getOutDirs");
function getCanonicalOrigin(origins, countryCode) {
  if (isKarrotLocalCountryCode(countryCode)) {
    return origins[countryCode];
  }
  return origins["us" /* US */];
}
__name(getCanonicalOrigin, "getCanonicalOrigin");

// src/KarrotLocalCountryCode.ts
var KarrotLocalCountryCode = /* @__PURE__ */ ((KarrotLocalCountryCode2) => {
  KarrotLocalCountryCode2["CA"] = "ca";
  KarrotLocalCountryCode2["US"] = "us";
  KarrotLocalCountryCode2["JP"] = "jp";
  KarrotLocalCountryCode2["KR"] = "kr";
  KarrotLocalCountryCode2["UK"] = "uk";
  return KarrotLocalCountryCode2;
})(KarrotLocalCountryCode || {});
var karrotLocalCountryCodes = Object.values(KarrotLocalCountryCode);

// src/canonicalOrigins.ts
var canonicalOrigins = {
  alpha: {
    ["ca" /* CA */]: "https://alpha.karrotmarket.com",
    ["jp" /* JP */]: "https://alpha.karrotmarket.com",
    ["kr" /* KR */]: "https://alpha.daangn.com",
    ["us" /* US */]: "https://alpha.karrotmarket.com",
    ["uk" /* UK */]: "https://alpha.karrotmarket.com"
  },
  prod: {
    ["ca" /* CA */]: "https://www.karrotmarket.com",
    ["jp" /* JP */]: "https://www.karrotmarket.com",
    ["kr" /* KR */]: "https://www.daangn.com",
    ["us" /* US */]: "https://www.karrotmarket.com",
    ["uk" /* UK */]: "https://www.karrotmarket.com"
  }
};

// src/CommonSearchParamKey.ts
var CommonSearchParamKey = /* @__PURE__ */ ((CommonSearchParamKey2) => {
  CommonSearchParamKey2["In"] = "in";
  CommonSearchParamKey2["Search"] = "search";
  return CommonSearchParamKey2;
})(CommonSearchParamKey || {});

// src/isKarrotLocalCountryCode.ts
var isKarrotLocalCountryCode = /* @__PURE__ */ __name((countryCode) => {
  if (typeof countryCode !== "string") {
    return false;
  }
  return karrotLocalCountryCodes.some((code) => code === countryCode);
}, "isKarrotLocalCountryCode");

// src/parseKarrotInfraCountryCode.ts
var KarrotInfraCountryCode = /* @__PURE__ */ ((KarrotInfraCountryCode2) => {
  KarrotInfraCountryCode2["CA"] = "ca";
  KarrotInfraCountryCode2["JP"] = "jp";
  KarrotInfraCountryCode2["UK"] = "uk";
  KarrotInfraCountryCode2["KR"] = "kr";
  return KarrotInfraCountryCode2;
})(KarrotInfraCountryCode || {});
function parseKarrotInfraCountryCode(str) {
  switch (str) {
    case "us":
    case "ca":
      return "ca" /* CA */;
    case "jp":
      return "jp" /* JP */;
    case "gb":
    case "uk":
      return "uk" /* UK */;
    case "kr":
      return "kr" /* KR */;
    default:
      return "ca" /* CA */;
  }
}
__name(parseKarrotInfraCountryCode, "parseKarrotInfraCountryCode");

// src/parseKarrotLocalCountryCode.ts
var parseKarrotLocalCountryCode = /* @__PURE__ */ __name((countryCode) => {
  if (!isKarrotLocalCountryCode(countryCode) && countryCode !== "gb") {
    return "us" /* US */;
  }
  switch (countryCode) {
    case "ca":
      return "ca" /* CA */;
    case "us":
      return "us" /* US */;
    case "jp":
      return "jp" /* JP */;
    case "gb":
    case "uk":
      return "uk" /* UK */;
    case "kr":
      return "kr" /* KR */;
    default:
      throw new Error(
        `parseKarrotLocalCountryCode: unhandled country code: ${countryCode}`
      );
  }
}, "parseKarrotLocalCountryCode");
export {
  CommonSearchParamKey,
  KarrotInfraCountryCode,
  KarrotLocalCountryCode,
  buildRegionParamValue,
  canonicalOrigins,
  createCanonicalize,
  isKarrotLocalCountryCode,
  karrotLocalCountryCodes,
  normalizeUrl,
  parseHostname,
  parseKarrotInfraCountryCode,
  parseKarrotLocalCountryCode,
  parsePathname
};
/*! For license information please see index.mjs.LEGAL.txt */
//# sourceMappingURL=index.mjs.map
